<!-- eslint-disable-next-line @angular-eslint/template/alt-text -->
<img
  class="lqip-image fill"
  aria-hidden="true"
  [style.--lqip]="lqip()"
  [attr.src]="originalSrc() ?? fallbackSrc()"
  [attr.srcset]="srcSetAttr()"
  [attr.sizes]="sizes()"
  [ngClass]="{ 'fill-parent': fillParent(), scale: scale() }"
  [attr.loading]="loading()"
  [attr.decoding]="decoding()"
  [attr.fetchpriority]="fetchPriority()"
  [class]="aspectRatioClass()"
  [style.aspect-ratio]="customAspectRatio()"
/>
@if (alt()) {
  <img class="is-vishidden" aria-hidden="false" [attr.alt]="alt()" />
}
